import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken, Point, Rewards } from '@morpho-org/dapp-core';
import type { MerklTarget } from '@/components/common/RewardsHoverCard/MerklRewardsHoverCard';
import type { VaultV2ApyBreakdown } from '@/lib/procedures/vaultV2Apy.contract';
import { IconRewardHover } from '@/components/common/IconRewardHover';
import VaultV2SummaryRow from './VaultV2SummaryRow';
interface VaultV2SummaryApyRowProps {
  apy: {
    raw?: bigint | null;
    formatted: string;
    net?: bigint | null;
    points: Point[];
    rewards: Rewards[];
  };
  performanceFee?: bigint | null;
  managementFee?: bigint | null;
  vaultAsset: InterfaceToken | null | undefined;
  maxRate?: bigint | null;
  maxApy?: number | null;
  isRateCapped?: boolean;
  includesDonations?: boolean;
  apyBreakdown?: VaultV2ApyBreakdown | null;
  merklContext?: MerklTarget | null;
}
const VaultV2SummaryApyRow = t0 => {
  const $ = _c(19);
  const {
    apy,
    performanceFee,
    managementFee,
    vaultAsset,
    maxRate,
    maxApy,
    isRateCapped,
    includesDonations,
    apyBreakdown,
    merklContext
  } = t0;
  let t1;
  if ($[0] !== apy.net || $[1] !== apy.points || $[2] !== apy.raw || $[3] !== apy.rewards || $[4] !== apyBreakdown || $[5] !== includesDonations || $[6] !== isRateCapped || $[7] !== managementFee || $[8] !== maxApy || $[9] !== maxRate || $[10] !== performanceFee || $[11] !== vaultAsset) {
    t1 = {
      performanceFee,
      managementFee,
      apy: apy.raw,
      variant: "vault",
      netApy: apy.net,
      asset: vaultAsset,
      points: apy.points,
      rewards: apy.rewards,
      maxRate,
      maxApy,
      isRateCapped,
      includesDonations,
      apyBreakdown
    };
    $[0] = apy.net;
    $[1] = apy.points;
    $[2] = apy.raw;
    $[3] = apy.rewards;
    $[4] = apyBreakdown;
    $[5] = includesDonations;
    $[6] = isRateCapped;
    $[7] = managementFee;
    $[8] = maxApy;
    $[9] = maxRate;
    $[10] = performanceFee;
    $[11] = vaultAsset;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== apy.formatted) {
    t2 = <span className="text-3xs">{apy.formatted}</span>;
    $[13] = apy.formatted;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== merklContext || $[16] !== t1 || $[17] !== t2) {
    t3 = <VaultV2SummaryRow label="APY"><IconRewardHover RewardsHoverCardProps={t1} merklContext={merklContext} isReversed={true}>{t2}</IconRewardHover></VaultV2SummaryRow>;
    $[15] = merklContext;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
};
export default VaultV2SummaryApyRow;